import { HostVideoConnectionType, HostVideoDevice, VideoDeviceState } from '@ftr/contracts/regional-api'
import { AbstractBuilder } from '@ftr/foundation'

export class HostVideoDeviceBuilder extends AbstractBuilder<HostVideoDevice> {
  constructor() {
    super({
      name: 'Test Video Device',
      connectionType: HostVideoConnectionType.Local,
      deviceId: 'test-video-device',
      url: undefined,
      state: VideoDeviceState.Available,
    })
  }
}
